import React, { useCallback } from 'react';
import { log } from 'log';
import { useSetPlayerTags } from 'server';
import { useTranslations } from 'js/hooks/i18n';
import { CommonPopup } from 'js/components/common/popups/CommonPopup';

export const DepositReachedThresholdPopup = (props) => {
    const setPlayerTags = useSetPlayerTags();
    const t = useTranslations('playtech.mobile.system.popup.depositReachedThresholdPopup.');
    const onClose = useCallback(async () => {
        try {
            await setPlayerTags({ tags: [{
                name: 'depositThresholdConfirmation',
                value: 'confirmed',
                type: 'text'
            }] });
        } catch (error) {
            log('error', error);
        }
    }, [setPlayerTags]);

    return (
        <CommonPopup
            { ...props }
            onClose={onClose}
            title={t('title')}
            content={t('content')}
        />
    );
};
